import { Component, Inject, inject } from '@angular/core';
import { MAT_SNACK_BAR_DATA, MatSnackBarRef } from '@angular/material/snack-bar';

@Component({
  selector: 'app-pet24snackbar',
  templateUrl: './pet24snackbar.component.html',
  styleUrls: ['./pet24snackbar.component.css']
})
export class Pet24snackbarComponent {
  snackBarRef = inject(MatSnackBarRef);
  configTypes = {
    success: {icon:'check_circle', message: '', color: 'green'},
    error:   {icon:'cancel', message: '', color: 'red'},
    info:    {icon:'info', message: '', color: 'blue'},
    warning: {icon:'warning', message: '', color: 'yellow'},
    primary: {icon:'pets', message: '', color: 'pet-color-1'}
  };
  config = null;

  constructor(@Inject(MAT_SNACK_BAR_DATA) public data: any) {
    console.log(data);
    this.config = this.configTypes[data.type];
    this.config.message = data.message
  }

  ngOnInit() {}

}
